webpackJsonp([261081892830479],{

/***/ 1307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = AccountLocked;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assets = __webpack_require__(471);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _position = __webpack_require__(44);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _LandingPagesWrap = __webpack_require__(67);
	
	var _LandingPagesWrap2 = _interopRequireDefault(_LandingPagesWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var meta = {
	  title: 'Team - your account has been locked',
	  meta: [{
	    name: 'description',
	    content: 'Contact our support team to get access to your account.'
	  }, {
	    name: 'keywords',
	    content: 'enterprise design, design thinking, design thinking process'
	  }],
	  header: false,
	  footer: false
	};
	
	function AccountLocked(history) {
	  return _react2.default.createElement(
	    _Page2.default,
	    meta,
	    _react2.default.createElement(
	      _position2.default,
	      { type: 'absolute', location: 'all' },
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'middle' },
	        _react2.default.createElement(
	          'div',
	          { id: 'enterprise-form' },
	          _react2.default.createElement(
	            _LandingPagesWrap2.default,
	            { history: history, showBackButton: false },
	            _react2.default.createElement(
	              'div',
	              { className: 'marginTop-l' },
	              _react2.default.createElement(
	                _spacing2.default,
	                { size: 'm', position: 'topBottom', type: 'padding' },
	                _react2.default.createElement(
	                  _pageWrap2.default,
	                  { size: 'm', maxWidth: 840 },
	                  _react2.default.createElement(
	                    _grid2.default,
	                    { columns: 12, size: 'xl', alignItems: 'center' },
	                    _react2.default.createElement(
	                      _grid.GridItem,
	                      { columnSpan: 12, columnSpanM: 6 },
	                      _react2.default.createElement(
	                        _align2.default,
	                        { type: 'center', typeM: 'left' },
	                        _react2.default.createElement(_spacing2.default, { type: 'margin', size: 'm', position: 'top' }),
	                        _react2.default.createElement(
	                          _maxWidth2.default,
	                          { value: 280 },
	                          _react2.default.createElement(
	                            _heading2.default,
	                            { size: 'xxxl', weight: 'bold' },
	                            'Your Team account has expired'
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _spacing2.default,
	                          { type: 'margin', size: 'm', position: 'top' },
	                          _react2.default.createElement(
	                            _maxWidth2.default,
	                            { value: 280 },
	                            _react2.default.createElement(
	                              _paragraph2.default,
	                              { size: 'm', color: 'slate' },
	                              'Speak to the support team to update your subscription and reactivate your account.'
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _spacing2.default,
	                          { type: 'margin', size: 'm', position: 'top' },
	                          _react2.default.createElement(
	                            _link2.default,
	                            {
	                              type: 'blue',
	                              url: 'mailto:help@marvelapp.com',
	                              target: '_blank'
	                            },
	                            _react2.default.createElement(
	                              _button2.default,
	                              {
	                                size: 'medium',
	                                color: 'white',
	                                hover: 'green',
	                                background: 'blue'
	                              },
	                              'Contact Support'
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _grid.GridItem,
	                      { columnSpan: 12, columnSpanM: 6 },
	                      _react2.default.createElement(
	                        _align2.default,
	                        { type: 'center' },
	                        _react2.default.createElement(
	                          _spacing2.default,
	                          { size: 'm', position: 'top', type: 'margin' },
	                          _react2.default.createElement(_Image2.default, {
	                            alt: 'Trial expired, contact sales for more info',
	                            maxWidth: _assets2.default.illustration.maxWidth,
	                            src: _assets2.default.illustration.src,
	                            hasShadow: false,
	                            useImageTag: true
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	AccountLocked.propTypes = {
	  history: _propTypes2.default.object.isRequired
	};
	
	AccountLocked.defaultProps = {};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-team-account-expired-index-js-84d45f4d13f83d09dc75.js